<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>When your brain constantly runs 100 miles an hour, you might as well put it to good use. And when you have a tattoo above your heart that says “storyteller”—then get to it. And that’s what B.L. Berg has done with her debut novel, <em>Lady and the Tramp and Me.</em> For her inspiration is everywhere, and nothing can become absolutely everything when she’s sitting behind the laptop.</p>
<br/>
<br/>
<p style="text-align: center;">Visit her at:</p>
<p style="text-align: center;"><em>Facebook.com/BLBergAuthor</em></p>
<p style="text-align: center;"><em>Instagram.com/BLBergAuthor</em></p>
<br/>
<br/>
<br/>
<br/>
<br/>
<p style="text-align: center;">Also by B.L. Berg</p>
<p style="text-align: center;"><em>The Dream Maker and The Candy Cane</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?6512ed6e